@use '@design/components/custom-scroll/custom-scroll' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;
@use '@design/design-tokens/typography/typography' as *;

.optionWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;

  > svg {
    flex-shrink: 0;
  }
}

.label {
  @include typography-v2-body-sm;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subTrigger {
  @include border-radius-r1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin: 0 4px 0 8px;
  padding: 8px;
  cursor: pointer;
  outline: none;

  &[data-highlighted],
  &[data-state='open'] {
    background-color: var(--surface-hover);
  }
}

.subMenuContent {
  @include border-radius-r2;

  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 290px;
  max-width: 400px;
  max-height: min(
    412px,
    var(--radix-dropdown-menu-content-available-height, 412px)
  );
  padding: 8px 0;
  background-color: var(--surface-default);
  border: 1px solid var(--border-soft);
  z-index: var(--z-index-dropdown);
  overflow: hidden;
}

.connectorsList {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow-y: auto;

  @include custom-scroll-minimal;

  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--surface-neutral);
  }
}

.separator {
  height: 1px;
  background-color: var(--border-soft);
}

.connectorItem {
  display: flex;
  margin: 0 8px;
  outline: none;
}

.connectorToggle {
  @include border-radius-r1;

  justify-content: space-between;
  width: 100%;
  min-width: 0;
  padding: 8px;

  > span:first-child {
    min-width: 0;
  }

  [data-toggle-container] {
    flex-shrink: 0;
  }

  &:hover {
    background-color: var(--surface-hover);
  }
}

.disconnectedConnector {
  @include border-radius-r1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-width: 0;
  padding: 8px;
  border: none;
  outline: none;
  background: transparent;
  color: inherit;
  cursor: pointer;

  > svg {
    flex-shrink: 0;
  }

  &:hover {
    background-color: var(--surface-hover);
  }
}

.disconnectedIconWrapper {
  display: inline-flex;
  flex-shrink: 0;
}
